/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SchemaVersion } from './schemaVersion';
import { SapVersion } from './sapVersion';
import { ReportStatus } from './reportStatus';
import { ReportType } from './reportType';


/**
 * An object grouping the state & version of the report.
 */
export interface ReportState { 
    sapVersion: SapVersion;
    schemaVersionOriginal: SchemaVersion;
    reportStatus: ReportStatus;
    reportType: ReportType;
}
export namespace ReportState {
}


